import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { brand, navLinks } from "@/mocks/site";

export default function SiteHeader() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const transparent = isHome && !scrolled && !menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        transparent
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur border-b border-background-200"
      }`}
    >
      <div
        className={`flex items-center justify-between h-16 md:h-[72px] px-4 md:px-10 ${
          transparent ? "text-background-50" : "text-foreground-950"
        }`}
      >
        <Link to="/" className="flex items-center gap-2.5 group" aria-label={`${brand.name} 首页`}>
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-md transition-colors ${
              transparent ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50"
            }`}
          >
            <i className="ri-eye-off-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide">{brand.name}</span>
            <span
              className={`text-[10px] tracking-[0.28em] uppercase ${
                transparent ? "text-background-200" : "text-foreground-400"
              }`}
            >
              Investigate
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `px-3.5 py-2 text-sm rounded-md transition-colors ${
                  isActive
                    ? transparent
                      ? "text-background-50 bg-background-50/15"
                      : "text-primary-600 bg-primary-50"
                    : transparent
                      ? "text-background-100 hover:text-background-50 hover:bg-background-50/10"
                      : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/cases"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-folder-open-line" aria-hidden="true"></i>
            浏览档案库
          </Link>
        </div>

        <button
          type="button"
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl cursor-pointer"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
          aria-expanded={menuOpen}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-3-line"} aria-hidden="true"></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 text-foreground-950">
          <nav className="flex flex-col px-4 py-3" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm rounded-md ${
                    isActive ? "text-primary-600 bg-primary-50" : "text-foreground-700"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/cases"
              className="mt-2 inline-flex items-center justify-center gap-1.5 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium"
            >
              <i className="ri-folder-open-line" aria-hidden="true"></i>
              浏览档案库
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}